export const ROUTE_MY_TICKETS = 'orders';
export const ROUTE_MY_TICKET = ':orderId';
export const ROUTE_MY_TICKETS_ADD = 'add-order';
export const ROUTE_MY_TICKETS_SUBSCRIPTIONS = 'subscriptions';
export const ROUTE_MY_TICKETS_SUBSCRIPTION_ADD = 'new';
export const ROUTE_MY_TICKETS_SUBSCRIPTION_EDIT = ':subscriptionId';
